export const emptySetEditors = 'No editor found with that name';
export const assignEditorTitle = 'Assign an editor to this service request';
export const assignEditorPlaceholder = 'search for editors...';
export const assignEditorButton = 'assign editor';
export const addEditorButton = 'add editor';
export const addEditorSuccess = 'Successfully changed notes!';
export const addEditorError = 'No editor selected';
